import { createContext, useContext } from 'react';
const NO_FILTERS = {};
/**
 * Inert value for widgets rendered outside a dashboard (e.g. a page component): reading works,
 * writing is a no-op, so a filter widget never has to know where it is mounted.
 */
const STANDALONE = {
    filters: NO_FILTERS,
    setFilters: () => { },
    resetFilters: () => { },
};
export const DashboardFiltersContext = createContext(null);
/**
 * @export
 * Read and set the filters of the dashboard the widget is rendered in.
 *
 * Each `EmbeddedDashboard` owns its own filter state and merges it into every widget's props, so a
 * filter widget affects only its own dashboard — a dashboard inside a details panel and the one on
 * the page behind it stay independent, and a nested dashboard shadows its parent.
 *
 * @example
 * ```
 * const { filters, setFilters } = useDashboardFilters();
 * <DateRangePicker
 *     startDate={filters.startDate}
 *     endDate={filters.endDate}
 *     onChange={(startDate, endDate, preset) => setFilters(f => ({ ...f, startDate, endDate, preset }))}
 * />
 * ```
 */
export function useDashboardFilters() {
    var _a;
    return (_a = useContext(DashboardFiltersContext)) !== null && _a !== void 0 ? _a : STANDALONE;
}
